import { useId } from 'react';
import classNames from 'classnames';

import ChevronLine from '@/assets/icons/chevron_line.svg?component';
import { SvgIcon } from '@/components/atoms/SvgIcon/SvgIcon';
import { MenuTrigger } from '@/components/molecules/Menu';

import styles from './CheckboxMenu.module.scss';

interface CheckboxMenuToggleProps {
    label: string;
    hideLabel?: boolean;
    summary?: string;
    /** A visible label beside the menu, which then names the toggle instead of its own. */
    labelledBy?: string;
    isOpen: boolean;
    disabled: boolean;
}

/** The disclosure button: its label unless one sits beside it, the summary, the chevron. */
export default function CheckboxMenuToggle(props: CheckboxMenuToggleProps) {
    const { label, hideLabel = false, summary, labelledBy, isOpen, disabled } = props;
    // React's ids hold colons, which jsdom's selector engine cannot match in tests.
    const summaryId = useId().replaceAll(':', '');
    const ownLabel = labelledBy === undefined;

    return (
        <MenuTrigger
            variant="field"
            className={styles.toggle}
            disabled={disabled}
            aria-haspopup={false}
            aria-labelledby={ownLabel ? undefined : `${labelledBy} ${summaryId}`}>
            {ownLabel && (
                <span className={hideLabel ? styles.visuallyHidden : styles.toggleLabel}>
                    {label}
                </span>
            )}
            {/* Separates the two in the button's name; flex layout never renders it. */}
            {ownLabel && summary !== undefined && ' '}
            {summary !== undefined && (
                <span id={summaryId} className={styles.toggleSummary}>
                    {summary}
                </span>
            )}
            <SvgIcon
                icon={ChevronLine}
                size="small"
                className={classNames(styles.chevron, { [styles.chevronOpen]: isOpen })}
            />
        </MenuTrigger>
    );
}
